export const reduxKey = '@@coreBadge';

//# sourceMappingURL=constants.js.map